'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

var _Alert = require('../../ui/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tone-Banner (info). Faehrt seit 2026-06 ueber das zentrale <Alert>-Primitiv.
// Verhaltens-erhaltend: faExclamationCircle-Icon, width:100% (fullWidth=true),
// warningColor auf Border/Icon, Content fett (fontWeightBold) ohne eigene Textfarbe
// (der frueher auskommentierte color-Reset entfaellt damit sauber).
var Info = function Info(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    _Alert2.default,
    {
      className: className,
      tone: _Alert.ALERT_TONES.INFO,
      icon: _freeSolidSvgIcons.faExclamationCircle,
      fullWidth: true
    },
    children
  );
};

Info.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
} : {};

Info.defaultProps = {
  className: ''
};

exports.default = Info;
module.exports = exports['default'];